module.exports = __webpack_public_path__ + "img/番外_开国大典_02_登基.9d41ac36.png";